import { render, staticRenderFns } from "./taskManagementLung.vue?vue&type=template&id=8b82d8ba"
import script from "./taskManagementLung.vue?vue&type=script&lang=js"
export * from "./taskManagementLung.vue?vue&type=script&lang=js"
import style0 from "./taskManagementLung.vue?vue&type=style&index=0&id=8b82d8ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports